import { useState, useEffect, useCallback } from 'react';
import request from '../utils/request';
import type { SuggestionItem } from '../types/admin';

const useSuggestionManage = () => {
  const [data, setData] = useState<SuggestionItem[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await request.get<{ list: SuggestionItem[]; total: number }>('/suggestion/list', {
        params: { keyword, page, pageSize },
      });
      if (res?.success && res.data) {
        setData(res.data.list || []);
        setTotal(res.data.total || 0);
      } else {
        setData([]);
        setTotal(0);
      }
    } catch {
      setData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [keyword, page, pageSize]);

  const deleteSuggestion = useCallback(
    (id: number | string) => {
      return request.post<null>('/suggestion/delete', { id }).then((res) => {
        if (res?.success) {
          fetchData();
        }
      });
    },
    [fetchData],
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, total, loading, keyword, setKeyword, page, setPage, pageSize, setPageSize, fetchData, deleteSuggestion };
};

export default useSuggestionManage;
